import { CompanyEmailExtension, CompanyLogo } from 'models/companies'

export const USER_TYPE_ADMIN = 'Admin' as const
export const USER_TYPE_STANDARD = 'Standard' as const
export const USER_TYPE_LIMITED = 'Limited' as const

export type UserType =
  | typeof USER_TYPE_ADMIN
  | typeof USER_TYPE_STANDARD
  | typeof USER_TYPE_LIMITED

export interface User {
  id: number
  email: string
  first_name: string
  last_name: string
  is_billing_admin: boolean
  is_staff?: boolean
  is_superuser?: boolean
  date_joined: string
  last_login: string | null
  company: {
    name: string
    id: number
    email_extensions: Array<CompanyEmailExtension>
    logo: string
    is_activate: boolean
    stripe_customer_id: string | null
    intercom_workspace_id: string | null
    contract_start_date: string | null
    logos: CompanyLogo[]
    has_bison_workspace: boolean
  }
  is_active: boolean
  user_type?: UserType
}
